import React, { useState, useEffect } from 'react';
import { logUserInteraction } from '../lib/logger';

const BackToTop: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAtBottom, setIsAtBottom] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      const scrollTop = window.pageYOffset;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      // Show button when scrolled down 300px
      setIsVisible(scrollTop > 300);
      
      // Check if user is near the bottom (within 100px)
      setIsAtBottom(scrollTop + windowHeight >= documentHeight - 100);
    };

    // Add scroll event listener
    window.addEventListener('scroll', toggleVisibility);
    
    // Initial check
    toggleVisibility();

    // Cleanup
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    logUserInteraction('click', 'back_to_top_button', {
      scrollPosition: window.pageYOffset,
      isAtBottom,
      documentHeight: document.documentElement.scrollHeight,
      windowHeight: window.innerHeight,
    });
    
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={scrollToTop}
      className={`fixed right-6 z-50 p-3 rounded-full shadow-lg transition-all duration-300 ease-in-out transform hover:scale-110 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#4F46E5] ${
        isAtBottom 
          ? 'bottom-6 bg-[#4F46E5] text-white hover:bg-[#4338CA] shadow-xl scale-110' 
          : 'bottom-20 bg-white text-[#4F46E5] hover:bg-[#F5F3FF] border border-[#E5E7EB]'
      }`}
      aria-label="Back to top"
      title="Back to top"
    >
      <svg 
        className="w-6 h-6" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={2} 
          d="M5 10l7-7m0 0l7 7m-7-7v18" 
        />
      </svg>
    </button>
  );
};

export default BackToTop; 